module.exports = __webpack_public_path__ + "static/media/revlon3.9f476c73.jpg";